import merge from 'deepmerge';
const overwriteMerge = (dest, source) => source;
const TYPE = 'imagine.wizard.Pairing';
const dVal = {
  type: TYPE,
  steps: {
    pairUnpairSelection: {
      type: 'imagine.PairUnpairSelection'
    },
    selectPairAsset: {
      type: 'imagine.pairing.SelectPairAssetDevice',
      onNext: 'imagine.pairing.SelectChildPair',
      onBack: 'imagine.pairing.SelectPairUnpair'
    },
    selectPairTag: {
      type: 'imagine.pairing.SelectPairChildDevice',
      onBack: 'imagine.pairing.SelectAssetPair',
      onNext: 'imagine.pairing.SelectPairSummary'
    },
    pairSummary: {
      type: 'imagine.pairing.PairSummary',
      onBack: 'imagine.pairing.SelectChildPair',
      onNext: 'imagine.pairing.Pair'
    },
    selectUnpair: {
      type: 'imagine.pairing.SelectUnpairDevice',
      onBack: 'imagine.pairing.SelectPairUnpair',
      onNext: 'imagine.pairing.Unpair'
    },
    assetPaired: {
      type: 'imagine.pairing.AssetPaired',
      onBack: 'imagine.pairing.ReselectAssetPair',
      onNext: 'imagine.pairing.SelectAssetPair',
      image: {
        src: 'https://storage.googleapis.com/recovr-ui-assets/pairing-failure.png',
        alt: 'A link is pictured with a red X indicating an error'
      }
    },
    tagPaired: {
      type: 'imagine.pairing.TagPaired',
      onBack: 'imagine.pairing.ReselectChildPair',
      onNext: 'imagine.pairing.SelectChildPair',
      image: {
        src: 'https://storage.googleapis.com/recovr-ui-assets/pairing-failure.png',
        alt: 'A link is pictured with a red X indicating an error'
      }
    },
    pairingSuccess: {
      type: 'imagine.pairing.PairingSuccess',
      onNext: 'imagine.pairing.PairAnother',
      onBack: 'imagine.pairing.Close',
      image: {
        src: 'https://storage.googleapis.com/recovr-ui-assets/pairing-success.png',
        alt: 'A link is pictured with a green check indicating success'
      }
    },
    unpairingSuccess: {
      type: 'imagine.pairing.UnpairingSuccess',
      onNext: 'imagine.pairing.PairAnother',
      onBack: 'imagine.pairing.Close',
      image: {
        src: 'https://storage.googleapis.com/recovr-ui-assets/pairing-success.png',
        alt: 'A link is pictured with a green check indicating success'
      }
    },
    pairingError: {
      type: 'imagine.pairing.PairingError',
      onNext: 'imagine.pairing.PairAnother',
      onBack: 'imagine.pairing.Close'
    },
    unpairingError: {
      type: 'imagine.pairing.UnpairingError',
      onNext: 'imagine.pairing.UnpairAnother',
      onBack: 'imagine.pairing.Close'
    }
  },
  startStep: 'pairUnpairSelection',
  onOpen: 'imagine.pairing.onOpen'
};
function setOverrides(model, overrides) {
  const {
    type,
    ...rest
  } = model;
  if (Object.keys(rest).length === 0) {
    return model;
  }
  return {
    ...merge(rest, overrides, {
      arrayMerge: overwriteMerge
    }),
    type
  };
}
function create(overrides) {
  if (overrides) {
    return setOverrides(dVal, overrides);
  }
  return {
    ...dVal
  };
}
export default {
  create,
  TYPE,
  setOverrides
};